import { render, staticRenderFns } from "./CampaignSubject.vue?vue&type=template&id=89aaa800&"
import script from "./CampaignSubject.vue?vue&type=script&lang=js&"
export * from "./CampaignSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports